<template>
  <div
    v-if="show"
    :class="mergedClasses"
    role="alert"
    v-bind="passthroughAttrs"
  >
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdAlert',

  inheritAttrs: false,

  props: {
    show: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'secondary'
    }
  },

  emits: [],

  computed: {
    alertClasses() {
      return ['alert', `alert-${this.variant}`];
    },

    mergedClasses() {
      return [this.$attrs.class, this.alertClasses].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
